module.exports = "/_next/static/files/2aa89679570e7e66fa1e81b3a8adc963.svg";